import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from './select-next';

const maritalStatusOptions = [
  {
    name: 'Single',
    key: 'Single'
  },
  {
    name: 'Married',
    key: 'Married'
  },
  {
    name: 'Widowed',
    key: 'Widowed'
  }
];

const MaritalStatusSelect = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseSelect
      name="maritalStatus"
      label="Marital Status"
      options={maritalStatusOptions}
      transparent
      disabledStateValue={{ value: '', label: 'Marital Status' }}
      data-cv-test="maritalStatus"
      {...props}
      data-cv-test-override={dataCvTest || 'maritalStatus'}
    />
  );
};

MaritalStatusSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

MaritalStatusSelect.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default MaritalStatusSelect;
